import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {Agreement} from '@models/user/agreement';
import {EnvironmentConfig} from '@environments/environment';
import {FirebaseAuthenticationService} from '@services/firebase/auth/firebase-authentication.service';

@Component({
    selector: 'scitis-user-agreement',
    templateUrl: './agreement.component.html',
    styleUrls: ['./agreement.component.scss'],
    standalone: false
})
export class AgreementComponent implements OnInit {
  public isAgreementAccepted: boolean = false;
  public agreement: string = 'https://www.google.com';

  public agreementContainsUrl: boolean = true;
  public portalName: string = EnvironmentConfig.PortalSettings.portalTitle;

  constructor(private router: Router,
              private firebaseAuthenticationService: FirebaseAuthenticationService,
              private loadingIndicator: LoadingIndicatorService) {

  }

  ngOnInit(): void {
    this.loadingIndicator.show();
    this.firebaseAuthenticationService.getAgreement().subscribe((response: Agreement) => {
      this.handleAgreementRetrieveSuccess(response);
    }, (error: HttpResponse<any>) => {
      this.handleAgreementRetrieveError(error);
    });
  }

  public onCancel(): void {
    this.loadingIndicator.show();
    console.debug('agreement not accepted, logout');
    this.firebaseAuthenticationService.signOutUser();
  }

  public onAccept(): void {
    this.loadingIndicator.show();
    this.firebaseAuthenticationService.setAgreementAccepted().subscribe((_response: Agreement) => {
      console.debug('agreement accepted and successfully reported to backend');
      this.loadingIndicator.hide();
      this.router.navigate(['dashboard']);

    }, (error: HttpResponse<any>) => {
      console.error('error saving agreement to backend, logout', error);
      this.firebaseAuthenticationService.signOutUser();

    });
  }

  private handleAgreementRetrieveSuccess(agreementResponse: Agreement) {

    if (agreementResponse.user.agreementAccepted) {
      console.debug('agreementResponse already accepted, go to dashboard');
      this.router.navigate(['dashboard']);
    }
    this.agreementHasUrl(agreementResponse.agreement);
    this.agreement = agreementResponse.agreement;
    this.loadingIndicator.hide();
  }

  private handleAgreementRetrieveError(error: HttpResponse<any>) {
    console.log('error loading agreement, logout', error);
    this.loadingIndicator.hide();
    this.firebaseAuthenticationService.signOutUser();
  }

  private agreementHasUrl(agreement: string): void {
    if (agreement == null || agreement.length < 4) {
      this.agreementContainsUrl = false;
      return;
    }

    if (agreement.slice(0, 4) === 'http') {
      this.agreementContainsUrl = true;
    } else {
      this.agreementContainsUrl = false;
    }
  }

}
